<template>
  <v-container fluid>
    <CreateRegulatorModal />
    <EditRegulatorModal />
    <v-row>
      <v-col cols="12">
        <DataTable
          :headers="headers"
          :items="regulators"
          module="Regulator"
          model="regulators"
          delete-callback="deleteRegulatorById"
          @handlePageChanged="getRegulators"
          @handleEditItem="editRegulator"
        >
          <template #top>
            <TableTopToolbar
              entity="Szabályozó típus"
              title="Szabályozó típusok"
              model="regulators"
              @filter="getRegulators"
            />
          </template>
        </DataTable>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters("Regulator", ["headers", "regulators"])
  },
  mounted() {
    this.getRegulators();
  },
  methods: {
    ...mapActions("Regulator", ["getRegulators", "editRegulator"])
  }
};
</script>

<style></style>
